module.exports = __webpack_public_path__ + "static/running-pro-2-88512349d0b28591855cae4c7e68f278.jpg";